import { Component, HostListener, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'viva-permission-popup',
    templateUrl: './viva-permission-popup.component.html',
    styleUrls: ['./viva-permission-popup.component.scss'],
    standalone: false
})
export class VivaPermissionPopupComponent {

  readonly dialogTitleId = 'viva-permission-popup-title';

  @Input() message?: string;
  @Input() animatedGif?: string;
  @Input() buttonText?: string = 'viva-permission-popup-component.button-ok';

  constructor(private modalController: ModalController) { }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    void this.dismiss();
  }

 async dismiss() {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }

}
